import React from "react";
import Seo from "../seo/Seo";

const Mapa = () => {
  return (
    <div className="container my-5">
      <Seo
        title="Mapa de Aulas | Life Center"
        description="Mapa de aulas e marcações do Life Center."
        path="/mapa-de-aulas"
        noindex
      />
      <h1>Mapa de Aulas</h1>
      <p>Em breve disponibilizaremos aqui o mapa de aulas atualizado.</p>
    </div>
  );
};

export default Mapa;
